module.exports = __webpack_public_path__ + "Flag-96.bf43630ca00f5340d0e25ed1b4a0bf6d.svg";